import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithAuth } from '../../../services/api-base';
import { toHttpsUrl } from '../../../util/formatting';
import type {
  EntityAndUserRequest,
  RegisterFormValues,
  AdditionalDetailsFormValues,
  RegistrationUserRequest,
  RegistrationUpdateUserRequest,
  RegistrationEntityRequest,
  UserResponse,
} from '../../../types/registration.types';

export const registrationApi = createApi({
  reducerPath: 'registrationApi',
  baseQuery: baseQueryWithAuth,
  endpoints: (builder) => ({
    register: builder.mutation<UserResponse, RegisterFormValues>({
      query: (values) => {
        const user: RegistrationUserRequest = {
          firstName: values.firstName,
          lastName: values.lastName,
          email: values.email,
          mobile: values.phone.replace(/\D/g, ''),
        };
        const entity: RegistrationEntityRequest = {
          entityName: values.companyName,
          propertiesOwned: values.properties,
          website: toHttpsUrl(values.website),
        };
        const body: EntityAndUserRequest = { entity, user: [user] };
        return { url: '/entity-service/api/v1/entities', method: 'POST', body };
      },
    }),

    updateDetails: builder.mutation<
      UserResponse,
      { values: AdditionalDetailsFormValues; userId: string | null }
    >({
      query: ({ values, userId }) => {
        const user: RegistrationUpdateUserRequest = {
          firstName: values.firstName,
          lastName: values.lastName,
          mobile: values.phone.replace(/\D/g, ''),
          userId,
        };
        const entity: RegistrationEntityRequest = {
          entityName: values.companyName,
          propertiesOwned: values.properties,
          website: toHttpsUrl(values.website),
        };
        const body: EntityAndUserRequest = { entity, user: [user] };
        return { url: '/entity-service/api/v1/entities', method: 'POST', body };
      },
    }),

    resendVerificationEmail: builder.mutation<string, string>({
      query: (userId) => ({
        url: `/api/v1/users/${userId}/execute-actions-email`,
        method: 'PUT',
      }),
    }),
  }),
});

export const {
  useRegisterMutation,
  useUpdateDetailsMutation,
  useResendVerificationEmailMutation,
} = registrationApi;
